import React from "react";
import { Accordion } from "src/components/general/accordion";
import { workAndProdAccordion } from "src/data/pricingPersonalData";

export const WorkPlanAcordion = (): React.JSX.Element => {
  return (
    <Accordion
      className="@container mt-5 w-3/4"
      trigger={
        <div className="flex w-full @[1366px]:items-start items-center justify-center rounded-lg @[1366px]:text-start">
          <div className="@[1366px]:mr-0 mr-16 flex @[1366px]:flex-row flex-col">
            <div className="flex @[1366px]:grid @[1366px]:grid-cols-4 flex-col @[1366px]:gap-54">
              <div className="flex @[1366px]:w-[400px] w-full @[830px]:flex-row @[1366px]:flex-col flex-col @[1366px]:items-start items-center justify-center">
                <h3 className="font-medium">{workAndProdAccordion.trigger.title} &nbsp;</h3>
                <p className="text-base text-white-300">
                  {workAndProdAccordion.trigger.description}
                </p>
              </div>

              {workAndProdAccordion.trigger.items.map((item, index) => (
                <div key={index} className="@[1366px]:flex hidden items-center justify-center p-4">
                  <span className="inline-flex h-10 items-center justify-center">
                    {!item.isIcon ? (
                      <span className="w-[100px] text-white-100">{item.text}</span>
                    ) : (
                      <div className="w-[100px]">
                        <span className={item.iconifyClassName} />
                      </div>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
    >
      {workAndProdAccordion.content.map((item, index) => (
        <div
          key={index}
          className="flex w-full @[1366px]:items-start items-center justify-center rounded-lg @[1366px]:text-start"
        >
          <div className="flex @[1366px]:flex-row flex-col">
            <div
              className="-ml-9 @[1366px]:mt-0 mt-2 @[1366px]:ml-0 flex @[1366px]:hidden w-full items-center justify-center text-center"
              key={index}
            >
              {item.title}
            </div>
            <div className="-mt-5 @[1366px]:-mt-1 grid @[1366px]:grid-cols-4 grid-cols-3 gap-55">
              <div className="@[1366px]:flex hidden w-[400px] flex-col justify-center" key={index}>
                {item.title}
              </div>
              {item.items.map((item, index) => (
                <div key={index} className="flex items-center justify-center p-4">
                  <span className="inline-flex h-10 items-center justify-center">
                    {!item.isIcon ? (
                      <span className="@[1366px]:mb-0 mb-8 w-[100px] items-center @[1366px]:text-base text-white-100">
                        {item.text}
                      </span>
                    ) : (
                      <div className="w-[100px]">
                        <span className={item.iconifyClassName} />
                      </div>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
          {index !== workAndProdAccordion.content.length - 1 ? (
            <div className="-ml-16 absolute mt-16 h-[1px] w-3/4 bg-white-600" />
          ) : null}
        </div>
      ))}
    </Accordion>
  );
};
